import {configureStore} from '@reduxjs/toolkit'

import userSlice from './system/user/userSlice'
import roleSlice from './system/role/roleSlice'
import passwordSlice from './password/passwordSlice'
import campusSlice from './system/campus/campusSlice'
import generalSlice from './general/generalSlice'
import kankorSlice from './dua/kankor/kankorSlice'
import academicSlice from './dua/academic/academicSlice'
import positionSlice from './dua/hr/positionSilce'
import schoolSlice from './system/school/schoolSlice'
import studentSlice from './dua/student/studentSlice'
import toolsSlice from './system/tools/toolsSlice'
import OrganizationSlice from './dua/hr/organizationSlice'
import studentInvoiceSlice from './dua/finance/studentInvoiceSlice'
import attendanceSlice from './dua/hr/attendanceSlice'
import classRoomSlice from './dphs/classRoom/classRoomSlice'
import studentAttendanceSlice from './dua/student/studentAttendanceSlice'
import studentScoreSlice from './dua/student/studentScoreSlice'
import schoolStudentSlice from './dphs/student/schoolStudentSlice'
import itemSlice from './canteen/itemSlice'
import purchaseSlice from './canteen/purchaseSlice'
import saleSlice from './canteen/saleSlice'
import lecturerPortalSlice from './dua/lecturer-portal/lecturerPortalSlice'
import dashboardSlice from './canteen/dashboardSlice'
import StudentPortalSlice from './dua/student-portal/StudentPortalSlice'
import staffSlice from './dua/hr/staffSlice'
import lecturerSlice from './dua/hr/lecturerSlice'
import financeCategorySlice from './dua/finance/financeCategorySlice'
import financeItemsSlice from './dua/finance/financeItemsSlice'
import financePurchaseSlice from './dua/finance/financePurchaseSlice'
import distributionSlice from './dua/hr/distributionSlice'
import paymentsSlice from './dua/finance/paymentsSlice'
import ItemDepreciationSlice from './dua/finance/ItemDepreciationSlice'
import librarySlice from './dua/library/librarySlice'
import schoolCompanySlice from './dphs/finance/companySlice'
import schoolFinanceCategorySlice from './dphs/finance/financeCategorySlice'
import schoolFinanceItemsSlice from './dphs/finance/financeItemsSlice'
import schoolFinancePurchaseSlice from './dphs/finance/financePurchaseSlice'
import schoolItemDepreciationSlice from './dphs/finance/ItemDepreciationSlice'
import bookPurchaseSlice from './dphs/finance/bookPurchaseSlice'
import bookStockSlice from './dphs/finance/bookStockSlice'
import uniformPurchaseSlice from './dphs/finance/uniformPurchaseSlice'
import uniformStockSlice from './dphs/finance/uniformStockSlice'
import bookDepreciationSlice from './dphs/finance/bookDepreciationSlice'
import uniformDepreciationSlice from './dphs/finance/uniformDepreciationSlice'

import schoolPositionSlice from './dphs/hr/positionSlice'
import schoolOrganizationSlice from './dphs/hr/organizationSlice'
import employeeSlice from './dphs/hr/employeeSlice'
import schoolAttendanceSlice from './dphs/hr/attendanceSlice'
import itemDistributionSlice from './dphs/hr/itemDistributionSlice'
import studentFeeSlice from './dphs/finance/studentFeeSlice'
import studentUniformSlice from './dphs/finance/studentUniformSlice'
import studentBookSlice from './dphs/finance/studentBookSlice'
import studentTransportPayments from './dphs/finance/studentTransportPayments'
import schoolPaymentsSlice from './dphs/finance/paymentsSlice'
import schoolDailyExpenseSlice from './dphs/finance/dailyExpenseSlice'
import chatSlice from './chat/chatSlice'

export const store = configureStore({
  reducer: {
    user: userSlice,
    role: roleSlice,
    passwordSlice: passwordSlice,
    campus: campusSlice,
    general: generalSlice,
    kankor: kankorSlice,
    academic: academicSlice,
    staff: staffSlice,
    position: positionSlice,
    school: schoolSlice,
    student: studentSlice,
    tools: toolsSlice,
    organization: OrganizationSlice,
    studentInvoice: studentInvoiceSlice,
    attendance: attendanceSlice,
    classRoom: classRoomSlice,
    studentAttendance: studentAttendanceSlice,
    studentScore: studentScoreSlice,
    schoolStudent: schoolStudentSlice,
    item: itemSlice,
    purchase: purchaseSlice,
    sale: saleSlice,
    lecturerPortal: lecturerPortalSlice,
    canteenDashboard: dashboardSlice,
    studentPortal: StudentPortalSlice,
    lecturer: lecturerSlice,
    financeCategory: financeCategorySlice,
    financeItemSlice: financeItemsSlice,
    financePurchaseSlice: financePurchaseSlice,
    distributionSlice: distributionSlice,
    paymentsSlice: paymentsSlice,
    itemDepreciationSlice: ItemDepreciationSlice,
    library: librarySlice,
    schoolCompanySlice: schoolCompanySlice,
    schoolFinanceCategorySlice: schoolFinanceCategorySlice,
    schoolFinanceItemsSlice: schoolFinanceItemsSlice,
    schoolFinancePurchaseSlice: schoolFinancePurchaseSlice,
    schoolItemDepreciationSlice: schoolItemDepreciationSlice,
    bookPurchaseSlice: bookPurchaseSlice,
    bookStockSlice: bookStockSlice,
    uniformPurchaseSlice: uniformPurchaseSlice,
    uniformStockSlice: uniformStockSlice,
    bookDepreciationSlice: bookDepreciationSlice,
    uniformDepreciationSlice: uniformDepreciationSlice,
    schoolPositionSlice: schoolPositionSlice,
    schoolOrganizationSlice: schoolOrganizationSlice,
    employeeSlice: employeeSlice,
    schoolAttendanceSlice: schoolAttendanceSlice,
    itemDistributionSlice: itemDistributionSlice,
    studentFeeSlice: studentFeeSlice,
    studentBookSlice: studentBookSlice,
    studentUniformSlice: studentUniformSlice,
    studentTransportPayments: studentTransportPayments,
    schoolPaymentsSlice: schoolPaymentsSlice,
    schoolDailyExpenseSlice: schoolDailyExpenseSlice,
    chat: chatSlice,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
